import { createApp } from 'vue';
import App from './App.vue';
import router from './router' 
import store from './store';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.min.css'
import Formatters from '@/utils/formatters'
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const app = createApp(App);
app.use(store)
app.use(router)
app.use(Toast, {
    position: POSITION.BOTTOM_RIGHT,
});
store.dispatch('auth/initializeStore').then(() => {
app.config.globalProperties.$formatters = Formatters;
    app.mount('#app');
});
